import { InputAdornment, TextFieldProps, Typography } from "@mui/material";

export const dollarFractionAdornment: TextFieldProps["InputProps"] = {
  startAdornment: (
    <InputAdornment
      position="start"
      sx={{ marginLeft: 1, marginRight: -1, marginTop: "2px" }}
    >
      <Typography display="inline" sx={{ fontSize: "16px" }}>
        $0.
      </Typography>
    </InputAdornment>
  ),
};
